import { defineStore } from "pinia";
import vuexStore from "@/store/store";

export const useFreeSearchHistoryStore = defineStore("freeSearchHistory", {
  // State
  state: () => ({
    freeSearchHistory: [],
  }),

  // Getters
  getters: {
    doubleCount: (state) => state.count * 2,
  },

  // Actions
  actions: {
    setFreeSearchHistory() {
      let freeSearchesHistory =
        vuexStore.getters["userSearchHistory/getUserSearchHistory"];

      freeSearchesHistory = freeSearchesHistory.filter((h) => h.type == "free");
      freeSearchesHistory = freeSearchesHistory.map((r) => {
        return { id: r.id, data: r.info };
      });
      this.freeSearchHistory = freeSearchesHistory;
    },
  },
});
